import { SearchX } from 'lucide-react';
import { Card } from '@/shared/ui/card';

/** Equivalente a views/cartao_nao_encontrado.ejs — código digitado não corresponde a nenhum cartão pré-carregado. */
export function PublicInviteGiftNotFound() {
  return (
    <Card className="mx-auto max-w-md p-8 text-center">
      <SearchX className="mx-auto size-12 text-muted-foreground" />
      <h1 className="mt-4 text-xl font-semibold">Cartão não encontrado</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Não encontramos nenhum cartão com o código informado. Confira o código impresso no cartão e tente
        novamente.
      </p>
    </Card>
  );
}
